// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bcz_a bhr_b bhr_va bhr_rv bhr_rw bhr_vu","PanelFooter--link":"bcz_b"};